export const FREE_SCRIPT_LIMIT = 50

export const PREMIUM_TIERS = [
  "supporter", "goon", "goon_plus", "goon_max", "founder",
  // legacy names
  "goontier_1", "goontier_2", "goontier_basic", "goontier_pro",
]

// Feed this the real entitled tier (lib/entitlements.ts's entitledTierLabel),
// not the raw role -- being staff is not a paid tier (product decision
// 2026-09-20), so an admin/dev/moderator only counts as premium if they've
// actually subscribed or are a Founder.
export function isPremiumTier(tier?: string | null): boolean {
  return !!tier && PREMIUM_TIERS.includes(tier)
}
